import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("as_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token bad — clear
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/" && !path.startsWith("/register")) {
        localStorage.removeItem("as_token");
        localStorage.removeItem("as_user");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
